import { render, staticRenderFns } from "./NavLang.vue?vue&type=template&id=2b81186e&scoped=true&"
import script from "./NavLang.vue?vue&type=script&lang=js&"
export * from "./NavLang.vue?vue&type=script&lang=js&"
import style0 from "./NavLang.vue?vue&type=style&index=0&id=2b81186e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81186e",
  null
  
)

export default component.exports